export default __webpack_public_path__ + "static/media/groupMembers.7ab970e6.svg";